import React, { useEffect, /*useContext,*/ useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import constantData from "../constants/constantData.json";
import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import loaderIcon from '../assets/images/icons/loader.gif';
import uploadIcon from '../assets/images/icons/upload-cloud.svg';
import pptIcon from '../assets/images/icons/ppt.svg';
import deleteIcon from '../assets/images/icons/trash.svg';
import backButton from '../assets/images/back_button_arrow.svg';
import publishersIcon from '../assets/images/icons/publishers.svg';
import { Radio, Select, Col, Row, Space, Input, Checkbox, /*Modal, Switch*/ } from 'antd';
import { default as ReactSelect } from 'react-select';
// import googleIcon from '../assets/images/icons/google-ads.svg';
import FullLoader from "../assets/images/full-page-loader.gif"
import mediaKitIcon from '../assets/images/icons/download.svg';
import csvImage from '../assets/images/icons/csv_image.svg';
import { saveAs } from "file-saver";
import downloadCsvIcon from '../assets/images/icons/download_csv_icon.svg';



//------------------------------------------------------------------------------

function CategoryRows({
    node,
    selected,
    setSelected,
    searchTerm = "",
    defaultOpen = false
}) {
    // const [open, setOpen] = useState(defaultOpen);
    const [open, setOpen] = useState();
    const parentRef = useRef(null);

    const childIds = node.children?.map(c => c.id) || [];

    const allChildrenSelected =
        childIds.length > 0 &&
        (selected.has(node.id) || childIds.every(id => selected.has(id)));

    const someChildrenSelected =
        !selected.has(node.id) &&
        childIds.some(id => selected.has(id)) &&
        !allChildrenSelected;

    const parentChecked = selected.has(node.id);

    useEffect(() => {
        if (parentRef.current) parentRef.current.indeterminate = someChildrenSelected;
    }, [someChildrenSelected]);

    const toggleParent = (parentId, children = []) => {
        setSelected(prev => {
            const next = new Set(prev);

            if (next.has(parentId)) {
                // Unselect parent & children
                next.delete(parentId);
                children.forEach(ch => next.delete(ch.id));
            } else {
                // Select parent only (not children explicitly)
                next.add(parentId);
                children.forEach(ch => next.delete(ch.id));
            }

            return next;
        });
    };

    // Toggle child
    const toggleChild = (childId, parentId, children = []) => {
        setSelected(prev => {
            const next = new Set(prev);

            if (next.has(parentId)) {
                // parent was selected → expand into all children except the toggled one
                next.delete(parentId);
                children.forEach(ch => {
                    if (ch.id !== childId) next.add(ch.id);
                });
            } else {
                // parent not selected, toggle the child normally
                if (next.has(childId)) {
                    next.delete(childId);
                } else {
                    next.add(childId);
                }

                // If all children are now selected → collapse into parent
                const allChildrenNowSelected =
                    children.length > 0 && children.every(ch => next.has(ch.id));

                if (allChildrenNowSelected) {
                    children.forEach(ch => next.delete(ch.id));
                    next.add(parentId);
                }
            }

            return next;
        });
    };


    // filter visibility
    const parentMatches = node.name.toLowerCase().includes(searchTerm);
    const childMatches = (node.children || []).filter(c =>
        c.name.toLowerCase().includes(searchTerm)
    );

    if (searchTerm && !parentMatches && childMatches.length === 0) return null;

    return (
        <>

            {/* Parent row */}
            <tr className={`${parentChecked ? "is-selected" : ""} ${someChildrenSelected ? "is-partial" : ""}`}>
                {/* COL 1: parent checkbox ONLY */}
                <td className="cell checkbox-col">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        ref={parentRef}
                        checked={selected.has(node.id)}
                        onChange={() => toggleParent(node.id, node.children || [])}
                        aria-label={`Select ${node.name}`}
                    />

                </td>

                {/* COL 2: expander + name (children checkboxes live here, not in col 1) */}
                <td className="cell name-col">
                    {(node.children && node.children.length > 0) ? (
                        <button
                            type="button"
                            // className="caret"
                            onClick={() => setOpen(o => !o)}
                        >
                            {open ? <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1.5L6 6.5L11 1.5" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                                : <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 11L6.5 6L1.5 1" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            }
                        </button>
                    ) : (
                        <></>
                    )}
                    <span
                        className={`label ${(!node.children || node.children.length === 0) ? "no-children" : ""}`}
                    >
                        {node.name}
                    </span>
                    {/* <span className="label">{node.name}</span> */}
                </td>
            </tr>

            {/* Children */}
            {open &&
                (node.children || [])
                    .filter(ch => !searchTerm || ch.name.toLowerCase().includes(searchTerm))
                    .map(ch => (
                        <tr key={ch.id} className={selected.has(ch.id) || selected.has(node.id) ? "is-selected" : ""}>
                            {/* COL 1: empty (parents only here) */}
                            <td className="cell checkbox-col" />

                            {/* COL 2: child checkbox + name */}
                            <td className="cell name-col child">
                                <span className="indent" />
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={selected.has(ch.id) || selected.has(node.id)}   // 👈 fix here
                                    onChange={() => toggleChild(ch.id, node.id, node.children)}
                                    aria-label={`Select ${ch.name}`}
                                />
                                <span className="label">{ch.name}</span>
                            </td>
                        </tr>
                    ))}
        </>
    );
}

//-----------------------------------------------------------------------------




const PublisherViewEdit = ({ handlePageViewChange, id, accountStatus, publisherViewName }) => {


    // const scrollToItem = (ref, offset = 80) => { ... }; // unused



    //--------------------------------------------------------------
    const [DATA, setDATA] = useState([]);
    const [selected, setSelected] = useState(new Set());
    const [search, setSearch] = useState("");
    const masterRef = useRef(null);
    const searchTerm = search.trim().toLowerCase();

    const parentIds = useMemo(() => DATA.map(node => node.id), [DATA]);
    const allSelectedAll = parentIds.every(id => selected.has(id));
    const someSelectedAll = !allSelectedAll && parentIds.some(id => selected.has(id));
    const visibleNodes = DATA.filter(node => {
        const parentMatches = node.name.toLowerCase().includes(searchTerm.toLowerCase());
        const childMatches = (node.children || []).some(c =>
            c.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return !searchTerm || parentMatches || childMatches;
    });

    function getSelectedChildrenCount(options, selected) {
        let count = 0;

        function findNodeById(nodes, id) {
            for (const node of nodes) {
                if (node.id === id) return node;
                if (node.children) {
                    const found = findNodeById(node.children, id);
                    if (found) return found;
                }
            }
            return null;
        }

        for (const id of selected) {
            const node = findNodeById(options, id);
            if (node) {
                if (node.children && node.children.length > 0) {
                    // parent selected → add number of children
                    count += node.children.length;
                } else {
                    // child selected → count 1
                    count += 1;
                }
            }
        }

        return count;
    }

    useEffect(() => {
        if (masterRef.current) {
            masterRef.current.indeterminate = someSelectedAll;
        }
    }, [someSelectedAll]);

    // useEffect(() => {
    //     if (masterRef.current) masterRef.current.indeterminate = someSelected;
    // }, [someSelected]);

    const handleMaster = () => {
        setSelected(prev => {
            const next = new Set();

            if (allSelectedAll) {
                // uncheck all
                return next;
            } else {
                // select only parent IDs (not children individually)
                DATA.forEach(node => {
                    next.add(node.id);
                });
            }

            return next;
        });
    };

    // useEffect(() => {
    //   console.log("✅ Selected IDs:", [...selected]);

    //   // If you want the full objects instead of just IDs:
    //   const selectedNodes = DATA.flatMap(parent => {
    //     const nodes = [];
    //     if (selected.has(parent.id)) nodes.push(parent);
    //     parent.children?.forEach(child => {
    //       if (selected.has(child.id)) nodes.push(child);
    //     });
    //     return nodes;
    //   });

    //   console.log("📌 Selected nodes:", selectedNodes);
    // }, [selected]);




    //---------------------------------------------------------------




    const [formVisible, setFormVisible] = useState(false);
    const [/* gamCheckboxPrev */, setGamCheckBoxPrev] = useState(null);
    // const [sellerObjectPrev, setSellerObjectPrev] = useState({ sellerType: "", sellerName: "", sellerDomain: "" })
    const [/* networkId */, setNetworkId] = useState("");


    React.useEffect(() => {

        axios
            .get(configData.SERVER_URL + "user/countryList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCountryOptions(response.data.data);
            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "user/iabCat", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDATA(response.data.data);
            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "user/dialCodeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDialCodeOptions(response.data.data);
            })
            .catch((error) => { });
    }, [])


    useEffect(() => {

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "ops/getPubDetails?_id=" + id, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setName(response.data.data.p_name)
                    setCompanyName(response.data.data.o_name)
                    setEmail(response.data.data.email)
                    setCompanyWebsite(response.data.data.c_website)
                    setAddress(response.data.data.address.address)
                    setState(response.data.data.address.state)
                    setCity(response.data.data.address.city)
                    setPincode(response.data.data.address.pincode)
                    setCountry(response.data.data.address.country)
                    setSelectedIm(response.data.data.im.label)
                    setIm(response.data.data.im.value)
                    if (response.data.data.phone.code.trim().length !== 0) {
                        setDialCode({ label: response.data.data.phone.code, value: response.data.data.phone.code })
                    }
                    setPhone(response.data.data.phone.p_number)
                    setCompanyLinkedin(response.data.data.o_contact)
                    setSellerType(response.data.data.s_type)
                    setSellerName(response.data.data.s_name)
                    setSellerDomain(response.data.data.s_domain)
                    // setIsGamChecked(response.data.data.gam_check)
                    // setGamCheckBoxPrev(response.data.data.gam_check)
                    // setSellerObjectPrev({ sellerType: response.data.data.s_type, sellerName: response.data.data.s_name, sellerDomain: response.data.data.s_domain })

                    // if (response.data.data.gam_check) {
                    //     setNetworkId(response.data.data.networkId ? response.data.data.networkId : "")
                    // }
                    setMediakit2(response.data.data.mediaKit)

                    if (response.data.data.source_type !== undefined) {
                        setSourceType(response.data.data.source_type)
                        if (response.data.data.source_type === "Direct") {
                            if (response.data.data.isMcmInvitationAccept_checkbox !== undefined) {
                                setSourceDirectCheckbox(response.data.data.isMcmInvitationAccept_checkbox)
                                if (response.data.data.isMcmInvitationAccept_checkbox) {
                                    setShareEmailId(response.data.data.shareEmailId === undefined ? "" : response.data.data.shareEmailId)
                                    setShareNetworkId(response.data.data.shareNetworkId === undefined ? "" : response.data.data.shareNetworkId)
                                }
                            }
                        }
                    }

                    if (response.data.data.integration_type !== undefined) {
                        setIntegrationType(response.data.data.integration_type)

                        if (response.data.data.integration_type.includes("ORTB")) {

                            if (response.data.data.ortb_type !== undefined) {
                                setOrtbType(response.data.data.ortb_type)
                            }
                        }

                        if (response.data.data.integration_type.includes("VAST")) {

                            if (response.data.data.vast_type !== undefined) {
                                setVastType(response.data.data.vast_type)
                            }
                        }
                    }

                    if (response.data.data.inventory_type !== undefined) {
                        setInventoryType(response.data.data.inventory_type)
                        if (response.data.data.inventory_type.includes("InApp")) {

                            if (response.data.data.inApp_mediakit !== undefined) {
                                setInappMediakit(response.data.data.inApp_mediakit)
                            }
                        }
                        if (response.data.data.inventory_type.includes("Website")) {

                            if (response.data.data.website_mediakit !== undefined) {
                                setWebsiteMediakit(response.data.data.website_mediakit)
                            }
                            if (response.data.data.isUserSync_checkbox !== undefined) {
                                setIsUserSyncDirectCheckbox(response.data.data.isUserSync_checkbox)
                            }
                            if (response.data.data.isRunningIbv_checkbox !== undefined) {
                                setIsRunningIbvCheckbox(response.data.data.isRunningIbv_checkbox)
                            }
                        }
                        if (response.data.data.inventory_type.includes("CTV")) {

                            if (response.data.data.ctv_mediakit !== undefined) {
                                setCtvMediakit(response.data.data.ctv_mediakit)
                            }
                        }

                        if (response.data.data.isSellerPassThrough_checkbox !== undefined) {
                            setIsSellerPassThroughCheckbox(response.data.data.isSellerPassThrough_checkbox)
                        }

                    }

                    if (response.data.data.blockCategory !== undefined) {
                        setSelected(new Set(response.data.data.blockCategory))
                    }



                    setFormVisible(true)
                })
                .catch((error) => {
                    setFormVisible(true)
                    notifyfailure("Failed to fetch the publisher details.")
                });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function resetViewPublisher() {
        setGamCheckBoxPrev(null)
        setNetworkId("")
        setFormVisible(false)
        setName("");
        setNameIsRequiredError(false);
        setCompanyName("");
        setCompanyNameIsRequiredError(false);
        setEmail("")
        setCompanyWebsite("");
        setCompanyWebsiteIsRequiredError(false);
        setCompanyWebsiteUrlError(false);
        setIm("");
        setImIsRequiredError(false);
        setSelectedIm("skype");
        setAddress("");
        setState("");
        setCity("");
        setPincode("");
        // setCountryOptions([]);
        setCountry("");
        setCountryIsRequiredError(false)
        // setDialCodeOptions([]);
        setDialCode({ label: "+91", value: "+91" });
        setPhone("");
        setPhoneIsRequiredError(false)
        setCompanyLinkedin("");
        setCompanyLinkedinUrlError(false)
        setSellerType("");
        setSellerName("");
        setSellerNameIsRequiredError(false)
        setSellerDomain("");
        setSellerDomainIsRequiredError(false)
        setSellerDomainUrlError(false)
        setIsGamChecked(false)
        setMediakit([]);
        setMediakit2([]);
        setButtonValue(false);
        setFormVisible(false)
    }





    ///////////////////////////////////////////onboarding related code starts  /////////////////////////////////////////////////////////////////////////////



    const formatOptionLabel = ({ value, label }) => (
        <div className="d-flex gap-10">
            <span>{label}</span><b>{value}</b>
            {/* <b>{label}</b> */}
        </div>
    );
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    React.useEffect(() => {
        setTimeout(() => {
            const reactInput = document.getElementById('react-select-5-input')
            reactInput?.setAttribute("placeholder", "Search");
        }, 1500);
    })

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [companyName, setCompanyName] = useState("");
    const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
        useState(false);

    const [email, setEmail] = useState("");

    const [companyWebsite, setCompanyWebsite] = useState("");
    const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
        useState(false);
    const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);
    const [selectedIm, setSelectedIm] = useState("telegram");

    // -----------------------------------------source/integration/inventory related code ---------------------------------//
    const [sourceType, setSourceType] = useState("");
    const [sourceDirectCheckbox, setSourceDirectCheckbox] =
        useState(false);

    const [shareEmailId, setShareEmailId] = useState("");
    const [shareEmailIdIsRequiredError, setShareEmailIdIsRequiredError] = useState(false);
    const [shareEmailIdUrlError, setShareEmailIdUrlError] = useState(false);

    const [shareNetworkId, setShareNetworkId] = useState("");
    const [shareNetworkIdIsRequiredError, setShareNetworkIdIsRequiredError] = useState(false);

    const [integrationType, setIntegrationType] = useState([]);
    const [ortbType, setOrtbType] = useState([]);
    const [ortbTypeIsRequiredError, setOrtbTypeIsRequiredError] = useState(false);
    const [vastType, setVastType] = useState([]);
    const [vastTypeIsRequiredError, setVastTypeIsRequiredError] = useState(false);


    const [inventoryType, setInventoryType] = useState([]);
    const [inappMediakit, setInappMediakit] = useState([]);
    const [inappMediakitIsRequiredError, setInappMediakitIsRequiredError] = useState(false);

    const [websiteMediakit, setWebsiteMediakit] = useState([]);
    const [websiteMediakitIsRequiredError, setWebsiteMediakitIsRequiredError] = useState(false);
    const [isUserSyncCheckbox, setIsUserSyncDirectCheckbox] =
        useState(false);
    const [isRunningIbvCheckbox, setIsRunningIbvCheckbox] =
        useState(false);

    const [ctvMediakit, setCtvMediakit] = useState([]);
    const [ctvMediakitIsRequiredError, setCtvMediakitIsRequiredError] = useState(false);

    const [isSellerPassThroughCheckbox, setIsSellerPassThroughCheckbox] =
        useState(false);


    //------------------------------------------source/integration/inventory related code ---------------------------------//


    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");

    const [countryOptions, setCountryOptions] = useState([]);
    const [country, setCountry] = useState("");
    const [countryIsRequiredError, setCountryIsRequiredError] = useState(false);

    const [dialCodeOptions, setDialCodeOptions] = useState([]);
    const [dialCode, setDialCode] = useState({ label: "+91", value: "+91" });
    const [phone, setPhone] = useState("");
    const [phoneIsRequiredError, setPhoneIsRequiredError] = useState(false);

    const [companyLinkedin, setCompanyLinkedin] = useState("");
    const [companyLinkedinUrlError, setCompanyLinkedinUrlError] = useState(false);

    const [sellerType, setSellerType] = useState("");

    const [sellerName, setSellerName] = useState("");
    const [sellerNameIsRequiredError, setSellerNameIsRequiredError] =
        useState(false);
    const [sellerDomain, setSellerDomain] = useState("");
    const [sellerDomainIsRequiredError, setSellerDomainIsRequiredError] =
        useState(false);
    const [sellerDomainUrlError, setSellerDomainUrlError] = useState(false);
    const [/* isGamChecked */, setIsGamChecked] = useState(false);

    const [mediakit, setMediakit] = useState([]);
    const [mediakit2, setMediakit2] = useState([]);

    const [buttonValue, setButtonValue] = useState(false);

    const fetchAndDownloadFilesMediaKit = async (ob) => {
        try {

            try {
                const response = await fetch(ob.url);

                if (!response.ok) {
                    throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
                }

                const blob = await response.blob();
                const filename = `${ob.fileName}${ob.fileName.includes("." + ob?.ext) ? "" : `${"." + ob.ext}`}`;

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;

                // Append the link to the body
                document.body.appendChild(link);

                // Programmatically click the link to trigger the download
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error fetching file:", error);
            }

            notifysuccess("File downloaded successfully");

        } catch (error) {
            notifyfailure("Error while fetching the media kit.");
        }
    };

    const fetchAndDownloadFiles = async (ob) => {
        try {

            try {
                const response = await fetch(ob.url);

                if (!response.ok) {
                    throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
                }

                const blob = await response.blob();
                const filename = `${ob.filename}${ob.filename.includes("." + ob?.ext) ? "" : `${"." + ob.ext}`}`;

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;

                // Append the link to the body
                document.body.appendChild(link);

                // Programmatically click the link to trigger the download
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error fetching file:", error);
            }

            notifysuccess("File downloaded successfully");

        } catch (error) {
            notifyfailure("Error while fetching the media kit.");
        }
    };



    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };


    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };

    const validateLinkedinUrl = (linkedinUrl) => {
        return String(linkedinUrl)
            .toLowerCase()
            .match(/^(https?:\/\/)?([^/]+\.)?(linkedin\.[a-zA-Z]+\/.*)$/);
    };

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }

    function onChangeCompanyName(event) {
        setCompanyNameIsRequiredError(false);
        setCompanyName(event.target.value);
    }

    function onBlurCompanyName(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyNameIsRequiredError(true);
            setCompanyName("");
        }
        setCompanyName(event.target.value.trim());
    }

    function onChangeCompanyWebsite(event) {
        setCompanyWebsite(event.target.value);

        if (event.target.value.length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            setCompanyWebsiteIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
    }

    function onBlurCompanyWebsite(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
        setCompanyWebsite(event.target.value.trim());
    }

    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim());
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    //------------------------------------------source/integration type related code starts --------------------------------------------//

    function onChangeSourceType(event) {
        setSourceType(event.target.value);
    }

    function onChangeSourceDirectCheckbox(event) {
        setSourceDirectCheckbox(event.target.checked);
    }


    function onChangeShareEmailId(event) {
        setShareEmailIdIsRequiredError(false);
        setShareEmailId(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setShareEmailIdUrlError(true);
        } else {
            setShareEmailIdUrlError(false);
        }
    }

    function onBlurShareEmailId(event) {
        if (event.target.value.trim().length === 0) {
            setShareEmailIdUrlError(false);
            setShareEmailIdIsRequiredError(true);
        } else {
            if (validateEmail(event.target.value.trim()) === null) {
                setShareEmailIdUrlError(true);
            } else {
                setShareEmailIdUrlError(false);
            }
        }
        setShareEmailId(event.target.value.trim());
    }


    function onChangeShareNetworkId(event) {
        setShareNetworkIdIsRequiredError(false);
        setShareNetworkId(event.target.value);
    }

    function onBlurShareNetworkId(event) {
        if (event.target.value.trim().length === 0) {
            setShareNetworkIdIsRequiredError(true);
        }
        setShareNetworkId(event.target.value.trim());
    }


    function onChangeIntegrationType(event) {
        setIntegrationType(event)
    }

    function onChangeOrtbType(event) {
        setOrtbType(event)
        if (event?.length === 0) {
            setOrtbTypeIsRequiredError(true)
        }
        else {
            setOrtbTypeIsRequiredError(false)
        }
    }

    function onChangeVastType(event) {
        setVastType(event)
        if (event?.length === 0) {
            setVastTypeIsRequiredError(true)
        }
        else {
            setVastTypeIsRequiredError(false)
        }
    }


    function onChangeInventoryType(event) {
        setInventoryType(event)
    }


    function onChangeInappMediakit(e) {
        let count = 0;

        if (e.target.files.length > 0) {
            const file = e.target.files[0]; // always pick the first file

            // check for CSV type
            if (file.size / (1024 * 1024) < 100 && (file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv"))) {
                // replace with the new file
                setInappMediakit([{
                    data: file,
                    preview: URL.createObjectURL(file),
                    filename: file.name,
                    size: file.size
                }]);
                setInappMediakitIsRequiredError(false)
            } else {
                count++;
            }

            // reset file input
            const fileInput001 = document.getElementById("file001");
            fileInput001.value = "";

            if (count !== 0) {
                notifyfailure("file is rejected as it is failing validation (File should be Less than 100mb && csv format");
            }
        }
    }


    function onChangeWebsiteMediakit(e) {
        let count = 0;

        if (e.target.files.length > 0) {
            const file = e.target.files[0]; // always pick the first file

            // check for CSV type
            if (file.size / (1024 * 1024) < 100 && (file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv"))) {
                // replace with the new file
                setWebsiteMediakit([{
                    data: file,
                    preview: URL.createObjectURL(file),
                    filename: file.name,
                    size: file.size
                }]);
                setWebsiteMediakitIsRequiredError(false)
            } else {
                count++;
            }

            // reset file input
            const fileInput002 = document.getElementById("file002");
            fileInput002.value = "";

            if (count !== 0) {
                notifyfailure("file is rejected as it is failing validation (File should be Less than 100mb && csv format");
            }
        }
    }

    function onChangeIsUserSyncCheckbox(event) {
        setIsUserSyncDirectCheckbox(event.target.checked);
    }


    function onChangeIsRunningIbvCheckbox(event) {
        setIsRunningIbvCheckbox(event.target.checked);
    }

    function onChangeCtvMediakit(e) {
        let count = 0;

        if (e.target.files.length > 0) {
            const file = e.target.files[0]; // always pick the first file

            // check for CSV type
            if (file.size / (1024 * 1024) < 100 && (file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv"))) {
                // replace with the new file
                setCtvMediakit([{
                    data: file,
                    preview: URL.createObjectURL(file),
                    filename: file.name,
                    size: file.size
                }]);
                setCtvMediakitIsRequiredError(false)
            } else {
                count++;
            }

            // reset file input
            const fileInput003 = document.getElementById("file003");
            fileInput003.value = "";

            if (count !== 0) {
                notifyfailure("file is rejected as it is failing validation (File should be Less than 100mb && csv format");
            }
        }
    }


    function onChangeIsSellerPassThroughCheckbox(event) {
        setIsSellerPassThroughCheckbox(event.target.checked);
    }


    //------------------------------------------source/integration type related code ends ---------------------------------------------//

    function onChangeAddress(event) {
        setAddress(event.target.value);
    }

    function onBlurAddress(event) {
        setAddress(event.target.value.trim());
    }

    function onChangeState(event) {
        setState(event.target.value);
    }

    function onBlurState(event) {
        setState(event.target.value.trim());
    }

    function onChangeCity(event) {
        setCity(event.target.value);
    }

    function onBlurCity(event) {
        setCity(event.target.value.trim());
    }

    function onChangePincode(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setPincode(event.target.value.trim());
        }
    }

    function onBlurPincode(event) {
        setPincode(event.target.value.trim())
    }

    function onChangePhone(event) {
        setPhoneIsRequiredError(false);
        if (/^\d*$/.test(event.target.value.trim())) {
            setPhone(event.target.value.trim());
        }
    }

    function onBlurPhone(event) {
        if (event.target.value.trim().length === 0) {
            setPhoneIsRequiredError(true);
        }
        setPhone(event.target.value.trim());
    }

    function onChangeCompanyLinkedin(event) {
        setCompanyLinkedin(event.target.value);
        if (event.target.value.length === 0) {
            setCompanyLinkedinUrlError(false);
        } else {
            if (validateLinkedinUrl(event.target.value) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
    }

    function onBlurCompanyLinkedin(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyLinkedinUrlError(false);
        }
        else {
            if (validateLinkedinUrl(event.target.value.trim()) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
        setCompanyLinkedin(event.target.value.trim());
    }


    function onChangeSellerType(event) {
        setSellerType(event.target.value);
    }

    function onChangeSellerName(event) {
        setSellerNameIsRequiredError(false);
        setSellerName(event.target.value);
    }

    function onBlurSellerName(event) {
        if (event.target.value.trim().length === 0) {
            setSellerNameIsRequiredError(true);
        }
        setSellerName(event.target.value.trim());
    }

    function onChangeSellerDomain(event) {
        setSellerDomain(event.target.value);

        if (event.target.value.length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            setSellerDomainIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
    }

    function onBlurSellerDomain(event) {
        if (event.target.value.trim().length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
        setSellerDomain(event.target.value.trim());
    }


    function onChangeMediakit(e) {
        let count = 0;

        if (e.target.files.length > 0) {
            let tempMediaKit = [...mediakit];

            for (let file of e.target.files) {

                if (file.size / (1024 * 1024) < 100 && (file.type === "application/vnd.ms-powerpoint" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation")) {
                    tempMediaKit.push({
                        data: file,
                        preview: URL.createObjectURL(file),
                        filename: file.name,
                        size: file.size
                    });
                }
                else {
                    count++;

                }
            }
            setMediakit(tempMediaKit);
            const fileInput00 = document.getElementById("file000");
            fileInput00.value = "";

            if (count !== 0) {
                notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && ppt/pptx format`)
            }

            //   } else {
            //     setMediakit({
            //       data: "",
            //       preview: "",
            //     });
            //     setMediakitFilename("");
            //     notifyfailure("File Size Should be less than 100 MB");
            //   }
        }
    }


    const handleDownload = async (type) => {


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(
                    configData.SERVER_URL +
                    `adsTxt/downloadDomain?type=` + type,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "text/csv;charset=utf-8",
                    });
                    saveAs(blob, "sample.csv");
                })
                .catch((error) => { });
        }
    };


    const basicDetailsRef = useRef(null)
    const sourceDetailsRef = useRef(null)
    const addressDetailsRef = useRef(null)
    const contactDetailsRef = useRef(null)
    const inventoryDetailsRef = useRef(null)
    const integrationDetailsRef = useRef(null)

    // const errorDetect = () => { ... }; // unused function




    const handleSubmit = async (e) => {
        e.preventDefault();


        // if (gamCheckboxPrev !== isGamChecked || sellerObjectPrev.sellerType !== sellerType || sellerObjectPrev.sellerName !== sellerName || sellerObjectPrev.sellerDomain !== sellerDomain) {

        if (
            name !== "" &&
            companyName !== "" &&
            companyWebsite !== "" &&
            im !== "" &&
            country !== "" &&
            phone !== "" &&
            sellerName !== "" &&
            sellerDomain !== "" &&
            ((sourceType === "Direct" && sourceDirectCheckbox) ? shareEmailId !== "" : true) &&
            ((sourceType === "Direct" && sourceDirectCheckbox) ? shareNetworkId !== "" : true) &&
            ((integrationType.includes("ORTB")) ? ortbType.length > 0 : true) &&
            ((integrationType.includes("VAST")) ? vastType.length > 0 : true) &&
            ((inventoryType.includes("InApp")) ? inappMediakit.length > 0 : true) &&
            ((inventoryType.includes("Website")) ? websiteMediakit.length > 0 : true) &&
            ((inventoryType.includes("CTV")) ? ctvMediakit.length > 0 : true) &&
            ((sourceType === "Direct" && sourceDirectCheckbox) ? shareEmailIdIsRequiredError === false : true) &&
            ((sourceType === "Direct" && sourceDirectCheckbox) ? shareEmailIdUrlError === false : true) &&
            ((sourceType === "Direct" && sourceDirectCheckbox) ? shareNetworkIdIsRequiredError === false : true) &&
            ((integrationType.includes("ORTB")) ? ortbTypeIsRequiredError === false : true) &&
            ((integrationType.includes("VAST")) ? vastTypeIsRequiredError === false : true) &&
            ((inventoryType.includes("InApp")) ? inappMediakitIsRequiredError === false : true) &&
            ((inventoryType.includes("Website")) ? websiteMediakitIsRequiredError === false : true) &&
            ((inventoryType.includes("CTV")) ? ctvMediakitIsRequiredError === false : true)
        ) {

            if (
                nameIsRequiredError === false &&
                companyNameIsRequiredError === false &&
                companyWebsiteUrlError === false &&
                companyWebsiteIsRequiredError === false &&
                imIsRequiredError === false &&
                countryIsRequiredError === false &&
                phoneIsRequiredError === false &&
                companyLinkedinUrlError === false &&
                sellerNameIsRequiredError === false &&
                sellerDomainIsRequiredError === false &&
                sellerDomainUrlError === false) {

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {



                    let formData = new FormData();

                    formData.append("p_name", name);
                    formData.append("o_name", companyName);
                    formData.append("email", email);
                    formData.append("c_website", companyWebsite);
                    formData.append("im", JSON.stringify({ "label": selectedIm, "value": im }));
                    formData.append("address", address);
                    formData.append("state", state);
                    formData.append("city", city);
                    formData.append("pincode", pincode);
                    formData.append("country", country);
                    formData.append("o_contact", companyLinkedin);
                    formData.append("phone", JSON.stringify({ "code": dialCode.value, "p_number": phone }));
                    formData.append("s_type", sellerType);
                    formData.append("s_name", sellerName);
                    formData.append("s_domain", sellerDomain);
                    // formData.append("gam_check", isGamChecked);
                    // formData.append("networkId", isGamChecked ? networkId : "");

                    formData.append("isSellerPassThrough_checkbox", isSellerPassThroughCheckbox)
                    //------source related code-------------------------//
                    formData.append("source_type", sourceType);
                    if (sourceType === "Direct") {
                        formData.append("isMcmInvitationAccept_checkbox", sourceDirectCheckbox);

                        if (sourceDirectCheckbox) {
                            formData.append("shareEmailId", shareEmailId);
                            formData.append("shareNetworkId", shareNetworkId);
                        }
                    }

                    formData.append("integration_type", JSON.stringify(integrationType))
                    if (integrationType.includes("ORTB")) {
                        formData.append("ortb_type", JSON.stringify(ortbType))
                    }
                    if (integrationType.includes("VAST")) {
                        formData.append("vast_type", JSON.stringify(vastType))
                    }

                    formData.append("inventory_type", JSON.stringify(inventoryType))
                    if (inventoryType.includes("InApp")) {
                        if (inappMediakit[0]?.hasOwnProperty('url')) {
                            formData.append("inApp_mediakit", JSON.stringify(inappMediakit))
                        }
                        else {
                            formData.append("inApp_mediakit", inappMediakit[0]?.data)
                        }

                    }
                    if (inventoryType.includes("Website")) {
                        if (websiteMediakit[0]?.hasOwnProperty('url')) {
                            formData.append("website_mediakit", JSON.stringify(websiteMediakit))
                        }
                        else {
                            formData.append("website_mediakit", websiteMediakit[0]?.data)
                        }
                        formData.append("isUserSync_checkbox", isUserSyncCheckbox)
                        formData.append("isRunningIbv_checkbox", isRunningIbvCheckbox)

                    }
                    if (inventoryType.includes("CTV")) {
                        if (ctvMediakit[0]?.hasOwnProperty('url')) {
                            formData.append("ctv_mediakit", JSON.stringify(ctvMediakit))
                        }
                        else {
                            formData.append("ctv_mediakit", ctvMediakit[0]?.data)
                        }
                    }

                    formData.append('blockCategory', JSON.stringify([...selected]));

                    //-------source related code------------------------//

                    formData.append("mediaKit", JSON.stringify(mediakit2));

                    mediakit?.forEach((file) => {
                        formData.append('mediaKit_new', file.data);
                    });


                    setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(configData.SERVER_URL + `ops/editPub?pubId=` + id, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {
                            notifysuccess(response.data.message);
                            handlePageViewChange("table", "yes")
                            resetViewPublisher()
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });
                }
            }
        }
        else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (companyName === "") {
                setCompanyNameIsRequiredError(true);
            }
            if (companyWebsite === "") {
                setCompanyWebsiteIsRequiredError(true);
            }
            if (im === "") {
                setImIsRequiredError(true);
            }
            if (country === "") {
                setCountryIsRequiredError(true);
            }
            if (phone === "") {
                setPhoneIsRequiredError(true);
            }
            if (sellerName === "") {
                setSellerNameIsRequiredError(true);
            }
            if (sellerDomain === "") {
                setSellerDomainIsRequiredError(true);
            }
            if ((sourceType === "Direct" && sourceDirectCheckbox) && shareEmailId === "") {
                setShareEmailIdIsRequiredError(true)
            }
            if ((sourceType === "Direct" && sourceDirectCheckbox) && shareNetworkId === "") {
                setShareNetworkIdIsRequiredError(true)
            }

            if (integrationType.includes("ORTB") && ortbType.length === 0) {
                setOrtbTypeIsRequiredError(true)
            }
            if (integrationType.includes("VAST") && vastType.length === 0) {
                setVastTypeIsRequiredError(true)
            }

            if (inventoryType.includes("InApp") && inappMediakit.length === 0) {
                setInappMediakitIsRequiredError(true)
            }

            if (inventoryType.includes("Website") && websiteMediakit.length === 0) {
                setWebsiteMediakitIsRequiredError(true)
            }

            if (inventoryType.includes("CTV") && ctvMediakit.length === 0) {
                setCtvMediakitIsRequiredError(true)
            }
        }
        // }


    };

    ///////////////////////////////////////////onboarding related code ends /////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className='container_box--breadcrumb-list'>
                        <li><Link onClick={() => {
                            handlePageViewChange("table", "no")
                            resetViewPublisher()
                        }} ><img src={publishersIcon} alt='USP' /> Publishers</Link></li>
                        <li className='primary'>View</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")
                                resetViewPublisher()
                            }}
                        />
                        <h1 className="heading">
                            {publisherViewName}
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    {formVisible &&
                        <>
                            <div className="container_box--width">


                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Basic details</label>
                                            <p className='sub_text'>General information overview</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container" ref={basicDetailsRef}>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Name *</label>
                                                        <Input
                                                            className={
                                                                nameIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={name}
                                                            onBlur={onBlurName}
                                                            onChange={onChangeName}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}
                                                        />
                                                        <span className='error_content'>
                                                            {nameIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Organisation Name *</label>
                                                        <Input
                                                            className={
                                                                companyNameIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={companyName}
                                                            onBlur={onBlurCompanyName}
                                                            onChange={onChangeCompanyName}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}
                                                        />
                                                        <span className="error_content">
                                                            {companyNameIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Email Address *</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={email}
                                                            disabled
                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Company website *</label>
                                                        <Input
                                                            className={
                                                                (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={companyWebsite}
                                                            onBlur={onBlurCompanyWebsite}
                                                            onChange={onChangeCompanyWebsite}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}
                                                        />
                                                        <span className="error_content">
                                                            {companyWebsiteIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                            {companyWebsiteUrlError && (
                                                                <> Invalid Website Url</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>IM *</label>
                                                        <Space.Compact className='form_compact basic disable_compact_d2'>
                                                            <Select
                                                                value={selectedIm}
                                                                onChange={onChangeSelectedIm}
                                                                options={constantData.IM_OPTIONS}
                                                                className='form_select'
                                                            // disabled={accountStatus !== "Approved"}
                                                            />
                                                            <Input
                                                                className={imIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                                }
                                                                value={im}
                                                                onChange={onChangeIm}
                                                                onBlur={onBlurIm}
                                                                autocomplete="off"
                                                            // disabled={accountStatus !== "Approved"}
                                                            />
                                                        </Space.Compact>
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>



                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Source</label>
                                            {/* <p className='sub_text'>Phone and other contact information</p> */}
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container" ref={sourceDetailsRef}>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className={sourceType !== "Direct" ? "form_content_block--group mb_0" : "form_content_block--group "}>
                                                        <label className='form_label d_flex'>Source Type</label>
                                                        <Radio.Group onChange={onChangeSourceType} value={sourceType} className="form_radio equal_space">
                                                            <Radio className='radio_btn source_radio_width2' value="Direct">Direct</Radio>
                                                            <Radio className='radio_btn source_radio_width2' value="SSP">SSP</Radio>

                                                        </Radio.Group>
                                                    </div>
                                                </Col>
                                                {sourceType === "Direct" &&
                                                    <>
                                                        <Col span={24}
                                                            style={{
                                                                height: sourceDirectCheckbox ? "" : "2rem"
                                                            }}
                                                        >
                                                            <div className="form_content_block--group">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        id="source_checkbox_direct"
                                                                        name="source_checkbox_direct"
                                                                        checked={sourceDirectCheckbox}
                                                                        onChange={onChangeSourceDirectCheckbox}
                                                                    >
                                                                        <span className="form_label">
                                                                            Do you accept MCM invitation?
                                                                        </span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {sourceDirectCheckbox &&
                                                            <>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group mb_0">
                                                                        <label className='form_label'>Share Email ID *</label>
                                                                        <Input
                                                                            className={(shareEmailIdIsRequiredError || shareEmailIdUrlError)
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                            }
                                                                            value={shareEmailId}
                                                                            onBlur={onBlurShareEmailId}
                                                                            onChange={onChangeShareEmailId}
                                                                            autocomplete="off"
                                                                        />
                                                                        <span className="error_content">
                                                                            {shareEmailIdIsRequiredError && (
                                                                                <> This field is required</>
                                                                            )}
                                                                            {shareEmailIdUrlError && (
                                                                                <>Invalid Email Address</>
                                                                            )}
                                                                        </span>

                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group mb_0">
                                                                        <label className='form_label'>Share Network ID *</label>
                                                                        <Input
                                                                            className={(shareNetworkIdIsRequiredError)
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                            }
                                                                            value={shareNetworkId}
                                                                            onBlur={onBlurShareNetworkId}
                                                                            onChange={onChangeShareNetworkId}
                                                                            autocomplete="off"
                                                                        />
                                                                        <span className="error_content">
                                                                            {shareNetworkIdIsRequiredError && (
                                                                                <> This field is required</>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>



                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Inventory</label>
                                            {/* <p className='sub_text'>Phone and other contact information</p> */}
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container" ref={inventoryDetailsRef}>
                                            <Row gutter={16}>
                                                <Col span={24}>

                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">Inventory Type </label>

                                                        <div className=''>
                                                            <Checkbox.Group className="form_checkbox equal_space"
                                                                value={inventoryType} onChange={onChangeInventoryType}
                                                            >
                                                                <Checkbox className="checkbox_btn integration_checkbox_width"
                                                                    value="InApp">
                                                                    InApp
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn integration_checkbox_width" value="Website"
                                                                >
                                                                    Website
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn integration_checkbox_width" value="CTV"
                                                                >
                                                                    CTV
                                                                </Checkbox>
                                                            </Checkbox.Group>
                                                        </div>
                                                    </div>
                                                </Col>

                                                {inventoryType.includes("InApp") &&
                                                    <Col span={24}>
                                                        <div className="form_content_block--group margin_top_24">
                                                            <label className="form_label">Upload InApp Inventory List * </label>

                                                            <label for='file001'
                                                                className="ant_upload_drag"
                                                            >
                                                                <p className="upload_drag_icon">
                                                                    <img src={uploadIcon} alt='USP' />
                                                                </p>
                                                                <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                                <p className="ant_upload_hint">
                                                                    CSV (max. 100 MB)
                                                                </p>
                                                            </label>
                                                            <input className='form_upload d-none' type="file"
                                                                name="file001"
                                                                id="file001"
                                                                accept=".csv"
                                                                // multiple
                                                                onChange={onChangeInappMediakit}


                                                            />
                                                            <div className="inventory_sample_download ">
                                                                <div
                                                                    onClick={() => { handleDownload("InApp") }}
                                                                >
                                                                    <div className="download_box">
                                                                        <img src={downloadCsvIcon} alt="" />

                                                                        <p>Download Sample Format</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <span className="error_content">
                                                                {inappMediakitIsRequiredError &&
                                                                    <>This field is required</>
                                                                }
                                                            </span>

                                                            {inappMediakit.map((media, index) => (

                                                                <div className="ant_upload_list--item">
                                                                    <div className="ant_upload_list--content">
                                                                        <img src={csvImage} alt="USP" />
                                                                        <div className="ant_upload_list--info">
                                                                            <span className="ant_upload_list--info-name">{media.filename}</span>
                                                                            {
                                                                                !media.hasOwnProperty('url') ?
                                                                                    <span className="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                                                                                    :
                                                                                    <span className="ant_upload_list--info-size"></span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify_content_end">
                                                                        {media.hasOwnProperty('url') &&
                                                                            <button className='download_icon download_icon_d2'
                                                                                onClick={() => {
                                                                                    fetchAndDownloadFiles(
                                                                                        media

                                                                                    )

                                                                                }}
                                                                            ><img src={mediaKitIcon} alt='USP' /></button>
                                                                        }
                                                                        <button type="link" className="ant_upload_list--delete"
                                                                            onClick={() => {
                                                                                let tempMediaKit = [...inappMediakit];
                                                                                tempMediaKit.splice(index, 1);
                                                                                setInappMediakit(tempMediaKit);
                                                                            }}
                                                                        >
                                                                            <img src={deleteIcon} alt="USP" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                }

                                                {inventoryType.includes("Website") &&
                                                    <Col span={24}>
                                                        <div className="form_content_block--group margin_top_24">
                                                            <label className="form_label">Upload Website Inventory List * </label>

                                                            <label for='file002'
                                                                className="ant_upload_drag"
                                                            >
                                                                <p className="upload_drag_icon">
                                                                    <img src={uploadIcon} alt='USP' />
                                                                </p>
                                                                <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                                <p className="ant_upload_hint">
                                                                    CSV (max. 100 MB)
                                                                </p>
                                                            </label>
                                                            <input className='form_upload d-none' type="file"
                                                                name="file002"
                                                                id="file002"
                                                                accept=".csv"
                                                                // multiple
                                                                onChange={onChangeWebsiteMediakit}


                                                            />
                                                            <div className="inventory_sample_download ">
                                                                <div
                                                                    onClick={() => { handleDownload("Website") }}
                                                                >
                                                                    <div className="download_box">
                                                                        <img src={downloadCsvIcon} alt="" />

                                                                        <p>Download Sample Format</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <span className="error_content">
                                                                {websiteMediakitIsRequiredError &&
                                                                    <>This field is required</>
                                                                }
                                                            </span>

                                                            {websiteMediakit.map((media, index) => (

                                                                <div className="ant_upload_list--item">
                                                                    <div className="ant_upload_list--content">
                                                                        <img src={csvImage} alt="USP" />
                                                                        <div className="ant_upload_list--info">
                                                                            <span className="ant_upload_list--info-name">{media.filename}</span>
                                                                            {
                                                                                !media.hasOwnProperty('url') ?
                                                                                    <span className="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                                                                                    :
                                                                                    <span className="ant_upload_list--info-size"></span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify_content_end">
                                                                        {media.hasOwnProperty('url') &&
                                                                            <button className='download_icon download_icon_d2'
                                                                                onClick={() => {
                                                                                    fetchAndDownloadFiles(
                                                                                        media

                                                                                    )

                                                                                }}
                                                                            ><img src={mediaKitIcon} alt='USP' /></button>
                                                                        }
                                                                        <button type="link" className="ant_upload_list--delete"
                                                                            onClick={() => {
                                                                                let tempMediaKit = [...websiteMediakit];
                                                                                tempMediaKit.splice(index, 1);
                                                                                setWebsiteMediakit(tempMediaKit);
                                                                            }}
                                                                        >
                                                                            <img src={deleteIcon} alt="USP" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            <div className="form_content_block--group "
                                                                style={{ marginBottom: "1rem" }}
                                                            >
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        id="user_sync_checkbox"
                                                                        name="user_sync_checkbox"
                                                                        checked={isUserSyncCheckbox}
                                                                        onChange={onChangeIsUserSyncCheckbox}
                                                                    >
                                                                        <span className="form_label">
                                                                            Do you support User Syncing?
                                                                        </span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                            <div className="form_content_block--group mb_0 ">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        id="running_ibv_checkbox"
                                                                        name="running_ibv_checkbox"
                                                                        checked={isRunningIbvCheckbox}
                                                                        onChange={onChangeIsRunningIbvCheckbox}
                                                                    >
                                                                        <span className="form_label">
                                                                            Is running IBV ads allowed over your inventory?
                                                                        </span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </Col>
                                                }

                                                {inventoryType.includes("CTV") &&
                                                    <Col span={24}>
                                                        <div className="form_content_block--group margin_top_24">
                                                            <label className="form_label">Upload CTV Inventory List * </label>

                                                            <label for='file003'
                                                                className="ant_upload_drag"
                                                            >
                                                                <p className="upload_drag_icon">
                                                                    <img src={uploadIcon} alt='USP' />
                                                                </p>
                                                                <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                                <p className="ant_upload_hint">
                                                                    CSV (max. 100 MB)
                                                                </p>
                                                            </label>
                                                            <input className='form_upload d-none' type="file"
                                                                name="file003"
                                                                id="file003"
                                                                accept=".csv"
                                                                // multiple
                                                                onChange={onChangeCtvMediakit}


                                                            />
                                                            <div className="inventory_sample_download ">
                                                                <div
                                                                    onClick={() => { handleDownload("CTV") }}
                                                                >
                                                                    <div className="download_box">
                                                                        <img src={downloadCsvIcon} alt="" />

                                                                        <p>Download Sample Format</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <span className="error_content">
                                                                {ctvMediakitIsRequiredError &&
                                                                    <>This field is required</>
                                                                }
                                                            </span>

                                                            {ctvMediakit.map((media, index) => (

                                                                <div className="ant_upload_list--item">
                                                                    <div className="ant_upload_list--content">
                                                                        <img src={csvImage} alt="USP" />
                                                                        <div className="ant_upload_list--info">
                                                                            <span className="ant_upload_list--info-name">{media.filename}</span>
                                                                            {
                                                                                !media.hasOwnProperty('url') ?
                                                                                    <span className="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                                                                                    :
                                                                                    <span className="ant_upload_list--info-size"></span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify_content_end">
                                                                        {media.hasOwnProperty('url') &&
                                                                            <button className='download_icon download_icon_d2'
                                                                                onClick={() => {
                                                                                    fetchAndDownloadFiles(
                                                                                        media

                                                                                    )

                                                                                }}
                                                                            ><img src={mediaKitIcon} alt='USP' /></button>
                                                                        }
                                                                        <button type="link" className="ant_upload_list--delete"
                                                                            onClick={() => {
                                                                                let tempMediaKit = [...ctvMediakit];
                                                                                tempMediaKit.splice(index, 1);
                                                                                setCtvMediakit(tempMediaKit);
                                                                            }}
                                                                        >
                                                                            <img src={deleteIcon} alt="USP" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                }

                                            </Row>
                                        </div>

                                    </Col>
                                </Row>


                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Integration</label>
                                            {/* <p className='sub_text'>Phone and other contact information</p> */}
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container" ref={integrationDetailsRef}>
                                            <Row gutter={16}>
                                                <Col span={24}>

                                                    <div className={(integrationType.length === 0 || (integrationType.length === 1 && integrationType.includes("Prebid"))) ? "form_content_block--group mb_0" : "form_content_block--group"}>
                                                        <label className="form_label">Integration Type </label>

                                                        <div className=''>
                                                            <Checkbox.Group className="form_checkbox equal_space"
                                                                value={integrationType} onChange={onChangeIntegrationType}
                                                            >
                                                                <Checkbox className="checkbox_btn integration_checkbox_width"
                                                                    value="Prebid">
                                                                    Prebid
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn integration_checkbox_width" value="ORTB"
                                                                >
                                                                    ORTB
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn integration_checkbox_width" value="VAST"
                                                                >
                                                                    VAST
                                                                </Checkbox>
                                                            </Checkbox.Group>
                                                        </div>
                                                    </div>

                                                    {integrationType.includes("ORTB") &&
                                                        <div className={!integrationType.includes("VAST") ? "form_content_block--group mb_0" : "form_content_block--group"}>
                                                            <label className="form_label">Select your counting method (ORTB) * </label>

                                                            <div className=''>
                                                                <Checkbox.Group className="form_checkbox equal_space"
                                                                    value={ortbType} onChange={onChangeOrtbType}
                                                                >
                                                                    <Checkbox className="checkbox_btn integration_checkbox_width"
                                                                        value="NURL">
                                                                        NURL
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn integration_checkbox_width" value="ADM"
                                                                    >
                                                                        ADM
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn integration_checkbox_width" value="BURL"
                                                                    >
                                                                        BURL
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                            </div>
                                                            <span className="error_content">
                                                                {ortbTypeIsRequiredError && <> Minimum 1 selection is required</>}
                                                            </span>
                                                        </div>
                                                    }

                                                    {integrationType.includes("VAST") &&
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">Select the supported VAST Version * </label>
                                                            <div className=''>
                                                                <Checkbox.Group className="form_checkbox equal_space"
                                                                    value={vastType} onChange={onChangeVastType}
                                                                >
                                                                    <Checkbox className="checkbox_btn integration_checkbox_width"
                                                                        value="VAST VERSION 2.0">
                                                                        VAST VERSION 2.0
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn integration_checkbox_width" value="VAST VERSION 3.0"
                                                                    >
                                                                        VAST VERSION 3.0
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn integration_checkbox_width" value="VAST VERSION 4.0"
                                                                    >
                                                                        VAST VERSION 4.0
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                            </div>
                                                            <span className="error_content">
                                                                {vastTypeIsRequiredError && <> Minimum 1 selection is required</>}
                                                            </span>
                                                        </div>
                                                    }
                                                </Col>

                                            </Row>
                                        </div>
                                    </Col>
                                </Row>


                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Block Category</label>
                                            {/* <p className='sub_text'>Phone and other contact information</p> */}
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <div className="block-category block_category_adjustment">
                                                <p className="subtitle">
                                                    Select all the categories that you want us to block for your supply *
                                                </p>

                                                <div className="form_content_block--group mb-0">
                                                    {/* <label className="form_label d-block">Exchanges Mapping *</label> */}
                                                    <div className="d_flex justify_content_between mb_10 align-items-center">
                                                        <Input
                                                            type='text'
                                                            className='form_control basic md search_input w_table_search'
                                                            placeholder="Search"
                                                            value={search}
                                                            onChange={e => setSearch(e.target.value)}
                                                        />
                                                        <span className='row_count_value_d2'>{getSelectedChildrenCount(DATA, selected)} Selected</span>
                                                    </div>
                                                </div>
                                                <div className="table-body-scroll">
                                                    <table className="category-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="cell checkbox-col"

                                                                    style={{ borderRight: "1px solid #EAECF0" }}>

                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        ref={masterRef}
                                                                        checked={allSelectedAll}
                                                                        onChange={handleMaster}
                                                                        aria-label="Select all"
                                                                    />
                                                                </th>
                                                                <th className="name-col">Name</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="scroll-body">
                                                            {DATA.length > 0 ? (

                                                                // DATA.map((node, index) => (
                                                                //   <CategoryRows
                                                                //     key={node.id}
                                                                //     node={node}
                                                                //     selected={selected}
                                                                //     setSelected={setSelected}
                                                                //     searchTerm={searchTerm}
                                                                //     defaultOpen={index === 0}
                                                                //   />
                                                                // ))

                                                                visibleNodes.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan={2} style={{ textAlign: "center", height: "20rem", width: "72rem" }}>
                                                                            <div className="no-data">No data found</div>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    visibleNodes.map(node => (
                                                                        <CategoryRows
                                                                            key={node.id}
                                                                            node={node}
                                                                            selected={selected}
                                                                            setSelected={setSelected}
                                                                            searchTerm={searchTerm.toLowerCase()}
                                                                        />
                                                                    ))
                                                                )



                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={2} style={{ textAlign: "center", height: "20rem", width: "72rem" }}>
                                                                        <div className="no-data">No data found</div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>


                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Contact details</label>
                                            <p className='sub_text'>Phone and other conact information</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container" ref={contactDetailsRef}>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Phone Number  *</label>
                                                        <div
                                                            // className={accountStatus !== "Approved" ? 'input_group input_group_disabled_d2' : 'input_group'}
                                                            className='input_group'
                                                        >
                                                            <ReactSelect
                                                                value={dialCode}
                                                                onChange={(event) => {
                                                                    setDialCode(event);
                                                                }}
                                                                options={dialCodeOptions}
                                                                isSearchable={true}
                                                                // menuIsOpen={true}
                                                                className="form_select--w-20"
                                                                classNamePrefix="form_select basic"
                                                                formatOptionLabel={formatOptionLabel}
                                                                styles={customStyles}
                                                                placeholder=""
                                                            // isDisabled={accountStatus !== "Approved"}
                                                            />
                                                            <Input
                                                                className={phoneIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                                }
                                                                value={phone}
                                                                onBlur={onBlurPhone}
                                                                onChange={onChangePhone}
                                                                autocomplete="off"
                                                            // disabled={accountStatus !== "Approved"}
                                                            />
                                                        </div>
                                                        {/* } */}
                                                        <span className="error_content">
                                                            {phoneIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Linkedin URL </label>
                                                        <Input
                                                            className={companyLinkedinUrlError
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            placeholder='https://'
                                                            value={companyLinkedin}
                                                            onBlur={onBlurCompanyLinkedin}
                                                            onChange={onChangeCompanyLinkedin}
                                                            // disabled={accountStatus !== "Approved"}
                                                            autocomplete="off"

                                                        />
                                                        <span className="error_content">
                                                            {companyLinkedinUrlError && (
                                                                <> Invalid LinkedIn Url</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Address</label>
                                            <p className='sub_text'>Location and mailing address</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container" ref={addressDetailsRef}>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Address Line 1</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={address}
                                                            onBlur={onBlurAddress}
                                                            onChange={onChangeAddress}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}

                                                        />

                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>City </label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={city}
                                                            onBlur={onBlurCity}
                                                            onChange={onChangeCity}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}

                                                        />

                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>State</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={state}
                                                            onBlur={onBlurState}
                                                            onChange={onChangeState}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}

                                                        />

                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Postal/ Zip Code  </label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={pincode}
                                                            onBlur={onBlurPincode}
                                                            onChange={onChangePincode}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}

                                                        />

                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                                        <label className='form_label'>Country  *</label>
                                                        <Select
                                                            showSearch
                                                            // open={true}
                                                            optionFilterProp="label"
                                                            className={countryIsRequiredError
                                                                ? "form_select basic error"
                                                                : "form_select basic"
                                                            }
                                                            value={country}
                                                            onChange={(event) => {
                                                                setCountryIsRequiredError(false)
                                                                setCountry(event);
                                                            }}
                                                            options={countryOptions}
                                                        // disabled={accountStatus !== "Approved"}
                                                        // onSearch={(value) => {
                                                        //     console.log('search:', value);
                                                        //   }}
                                                        />
                                                        <span className="error_content">
                                                            {countryIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Seller details</label>
                                            <p className='sub_text'>Seller's business specifics</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label d_flex'>Seller Type *</label>
                                                        <Radio.Group onChange={onChangeSellerType} value={sellerType}
                                                            // disabled={accountStatus !== "Approved"}

                                                            className="form_radio equal_space">
                                                            <Radio className='radio_btn' value="Publisher">Publisher</Radio>
                                                            <Radio className='radio_btn' value="Intermediary">Intermediary</Radio>
                                                            <Radio className='radio_btn' value="Both">Both</Radio>
                                                        </Radio.Group>
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Seller Name *</label>
                                                        <Input
                                                            className={sellerNameIsRequiredError
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            value={sellerName}
                                                            onBlur={onBlurSellerName}
                                                            onChange={onChangeSellerName}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}

                                                        />
                                                        <span className="error_content">
                                                            {sellerNameIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group ">
                                                        <label className='form_label'>Seller Domain *</label>
                                                        <Input
                                                            className={(sellerDomainIsRequiredError || sellerDomainUrlError)
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            value={sellerDomain}
                                                            onBlur={onBlurSellerDomain}
                                                            onChange={onChangeSellerDomain}
                                                            autocomplete="off"
                                                        // disabled={accountStatus !== "Approved"}

                                                        />
                                                        <span className="error_content">
                                                            {sellerDomainIsRequiredError && (
                                                                <> This field is required</>
                                                            )}

                                                            {sellerDomainUrlError && (
                                                                <> Invalid Domain</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={24}>
                                                    <div className="form_content_block--group mb_0 ">
                                                        <div className="primary_checkbox">
                                                            <Checkbox
                                                                id="running_ibv_checkbox"
                                                                name="running_ibv_checkbox"
                                                                checked={isSellerPassThroughCheckbox}
                                                                onChange={onChangeIsSellerPassThroughCheckbox}
                                                            >
                                                                <span className="form_label">
                                                                    Seller Passthrough
                                                                </span>
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                                {/* <Row gutter={16} className='mb-5'>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>GAM Integration</label>
                                            <p className='sub_text'>Google Ad Manager setup</p>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="google_ads_design_d2 form_content_block--group">
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex align-items-center'>
                                                    <img src={googleIcon} className='img-fluid' alt="" />
                                                    <label className='form_label'>Google Ad Manager 360 (MCM)</label>
                                                </div>
                                                <Switch checked={isGamChecked} onChange={() => { setIsGamChecked(!isGamChecked) }}
                                                    disabled={accountStatus !== "Approved" ? true : gamCheckboxPrev}

                                                />
                                            </div>
                                            {isGamChecked &&
                                                <div className="form_content_block--group mt_d2_24">
                                                    <Input className='form_control basic' placeholder="Enter Network ID"
                                                        value={networkId} onChange={(e) => { setNetworkId(e.target.value) }}
                                                        disabled={accountStatus !== "Approved" ? true : gamCheckboxPrev}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Col>
                                </Row> */}


                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Media Kit</label>
                                            <p className='sub_text'>Upload ppt</p>
                                        </div>
                                    </Col>


                                    <Col span={16}>
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group">

                                                    <>
                                                        <label for='file000'
                                                            className="ant_upload_drag mb-4"
                                                        // className={dragging ? 'ant_upload_drag drag_css_color' : 'ant_upload_drag'}
                                                        // onDragEnter={handleDragEnter}
                                                        // onDragOver={handleDragOver}
                                                        // onDragLeave={handleDragLeave}
                                                        // onDrop={handleDrop}
                                                        >
                                                            <p className="upload_drag_icon">
                                                                <img src={uploadIcon} alt='USP' />
                                                            </p>
                                                            <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                            <p className="ant_upload_hint">
                                                                PPT (max. 100 MB)
                                                            </p>
                                                        </label>
                                                        <input className='form_upload d-none' type="file"
                                                            name="file000"
                                                            id="file000"
                                                            accept=".ppt, .pptx"
                                                            multiple
                                                            onChange={onChangeMediakit}
                                                        />
                                                        {mediakit?.map((media, index) => (

                                                            <div className="ant_upload_list--item">
                                                                <div className="ant_upload_list--content">
                                                                    <img src={pptIcon} alt="USP" />
                                                                    <div className="ant_upload_list--info">
                                                                        <span className="ant_upload_list--info-name">{media.filename}</span>
                                                                        <span className="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                                                                    </div>
                                                                </div>

                                                                <button type="link" className="ant_upload_list--delete"
                                                                    onClick={() => {
                                                                        let tempMediaKit = [...mediakit];
                                                                        tempMediaKit.splice(index, 1);
                                                                        setMediakit(tempMediaKit);
                                                                    }}
                                                                >
                                                                    <img src={deleteIcon} alt="USP" />
                                                                </button>

                                                            </div>
                                                        ))}

                                                    </>


                                                    {mediakit2?.map((media, index) => (

                                                        <div className="ant_upload_list--item">
                                                            <div className="ant_upload_list--content">
                                                                <img src={pptIcon} alt="USP" />
                                                                <div className="ant_upload_list--info">
                                                                    <span className="ant_upload_list--info-name">{media.fileName}</span>
                                                                    {!media.hasOwnProperty('url') ?
                                                                        <span className="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                                                                        :
                                                                        <span className="ant_upload_list--info-size"></span>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify_content_end">
                                                                {media.hasOwnProperty('url') &&
                                                                    <button className='download_icon download_icon_d2'
                                                                        onClick={() => {
                                                                            fetchAndDownloadFilesMediaKit(
                                                                                media

                                                                            )

                                                                        }}
                                                                    ><img src={mediaKitIcon} alt='USP' /></button>
                                                                }
                                                                <button type="link" className="download_icon download_icon_d2"
                                                                    onClick={() => {
                                                                        let tempMediaKit = [...mediakit2];
                                                                        tempMediaKit.splice(index, 1);
                                                                        setMediakit2(tempMediaKit);
                                                                    }}
                                                                >
                                                                    <img src={deleteIcon} alt="USP" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                </Row>


                            </div>



                            <div className='mb_20'></div>

                            <>

                                <div className="height_89_d2"></div>
                                {buttonValue ?
                                    <div className=" btn_group justify-content-end gap_8 pb_50 ">
                                        <button className='w_120_d2 btn btn_primary w_fit_content'
                                            disabled
                                        >Update</button>
                                    </div> :
                                    <div className=" btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                                        <button className='w_120_d2 btn btn_white_outline w_fit_content'
                                            onClick={() => {
                                                handlePageViewChange("table", "no")
                                                resetViewPublisher()
                                            }}
                                        >Discard</button>
                                        <button className='w_120_d2 btn btn_primary w_fit_content'
                                            onClick={
                                                handleSubmit
                                            }
                                        // disabled={!formVisible || (isGamChecked === gamCheckboxPrev && sellerObjectPrev.sellerType === sellerType && sellerObjectPrev.sellerName === sellerName && sellerObjectPrev.sellerDomain === sellerDomain)}
                                        >Update</button>
                                    </div>
                                }
                            </>


                        </>
                    }
                    {!formVisible &&
                        <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                            <img src={FullLoader} className="mt-5" width={50} height={50} alt="" />
                        </div>
                    }
                </div>

            </div >
        </>

    )

}

export default PublisherViewEdit;